// extracted by mini-css-extract-plugin
var _1 = "HistoryRow-module__active--ynQ7s";
var _2 = "HistoryRow-module__animateUploadProgressBarWidth--luJ0C";
var _3 = "HistoryRow-module__animatedBackground--Ec27k";
var _4 = "HistoryRow-module__authors--HCoNx";
var _5 = "HistoryRow-module__button--rvHz9";
var _6 = "HistoryRow-module__container--_PQ1n";
var _7 = "HistoryRow-module__description--Zqrvz";
var _8 = "HistoryRow-module__isMenuOpen--7YXhp";
var _9 = "HistoryRow-module__menuContainer--WDQIm";
var _a = "HistoryRow-module__postIconWrapper--ws0nN";
var _b = "HistoryRow-module__timestamp--hRybh";
export { _1 as "active", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "authors", _5 as "button", _6 as "container", _7 as "description", _8 as "isMenuOpen", _9 as "menuContainer", _a as "postIconWrapper", _b as "timestamp" }
